import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Header } from "components/header/Header";
import moment from "moment";
import { loadState } from "library/helpers/sessionStorage";
import apiService from "services/apiservice";
import { Button, Modal } from "antd";
import { useIdleTimer } from "react-idle-timer";
import MainSider from "../sider/MainSider";
import MainContent from "../MainContent";
import { MainHeader } from "../MainHeader";
import * as S from "./styles";
import { MainFooter } from "../MainFooter";

const MainLayout = ({ children }: any) => {
  const navigate = useNavigate();
  const currentUser = loadState("loggedInUser");
  const targetDateTime = currentUser?.refreshExpiration;

  const targetMoment = moment(targetDateTime);

  const currentMoment = moment();

  const differenceInMilliseconds = targetMoment.diff(currentMoment);
  const timeout = Math.max(differenceInMilliseconds, 1);
  const promptBeforeIdle = timeout > 20_000 ? 20_000 : 0;
  const [remaining, setRemaining] = useState<number>(timeout);

  const [isTwoColumnsLayout] = useState(true);
  const [siderCollapsed, setSiderCollapsed] = useState(true);
  const [open, setOpen] = useState(false);

  const toggleSider = () => setSiderCollapsed(!siderCollapsed);

  const onIdle = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/session-expired");
  };

  const onActive = () => {
    setOpen(true);
  };

  const onPrompt = () => {
    setOpen(true);
  };

  const { getRemainingTime, activate } = useIdleTimer({
    onIdle,
    onActive,
    onPrompt,
    timeout,
    promptBeforeIdle,
    throttle: 500,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  });

  const handleStillHere = async () => {
    activate();
    await apiService.getRefreshToken();
    setOpen(false);
  };

  const displayPopupNotification = () => {
    return (
      <Modal
        zIndex={5000}
        maskClosable={false}
        title="Logout?"
        centered
        open={open}
        onOk={() => handleStillHere()}
        onCancel={() => {
          setOpen(false);
          localStorage.clear();
          sessionStorage.clear();
          navigate("/");
        }}
        footer={[
          <Button key="stay-logged-in" type="primary" onClick={handleStillHere}>
            Stay Logged in
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              sessionStorage.clear();
              localStorage.clear();
              navigate("/");
            }}
          >
            {`Log Off ${remaining}`}
          </Button>,
        ]}
      >
        <p>
          You session time is out, you will be automatically logged out in{" "}
          {remaining} seconds.
        </p>
      </Modal>
    );
  };

  return (
    <S.LayoutMaster>
      <MainSider
        isCollapsed={siderCollapsed}
        setCollapsed={setSiderCollapsed}
      />
      <S.LayoutMain>
        <MainHeader isTwoColumnsLayout={isTwoColumnsLayout}>
          <Header
            toggleSider={toggleSider}
            isSiderOpened={!siderCollapsed}
            isTwoColumnsLayout={isTwoColumnsLayout}
          />
        </MainHeader>
        <MainContent
          id="main-content"
          $isTwoColumnsLayout={isTwoColumnsLayout}
          style={{ background: "white" }}
        >
          <Outlet />
          {displayPopupNotification()}
          {children}
        </MainContent>
        <MainFooter isTwoColumnsLayout={isTwoColumnsLayout}>
          <div className="footer-content">
            &copy; {new Date().getFullYear()} PEGASUS LOGISTICS GROUP. ALL
            RIGHTS RESERVED
          </div>
        </MainFooter>
      </S.LayoutMain>
    </S.LayoutMaster>
  );
};

export default MainLayout;
